<script>
import { $http } from 'larasnap';

export default {
    methods: {
        $http(method, ...params) {
            return $http
                .route('snapgrid')
                .method('post')
                .hideErrorCode(504)
                .setData({
                    snapgrid: JSON.stringify({
                        props: this.props,
                        method,
                        params,
                    }),
                })
                .addResponseInterceptor(({ data }) => {
                    if (data?.props && data?.value) {
                        this.setProps(data.props);
                        return data.value;
                    } else {
                        return data;
                    }
                });
        },
    },
};
</script>
